enum ExceptionTypeEnum {
	platformComponentElement = 'platformComponentElement',
	platform = 'platform',
	componentElement = 'componentElement',
	component = 'component',
	service = 'service',
	generic = 'generic',
	serverErrorResponse = 'serverErrorResponse',
	connectionProblem = 'connectionProblem',
	unableToParseServerResponse = 'unableToParseServerResponse',
	invalidZipCode = 'invalidZipCode',
	shoppingCart = 'shoppingCart'
}

export default ExceptionTypeEnum;
